import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ProviderTypeService', ProviderTypeService);

  ProviderTypeService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'ProviderTypeModalService',
  ];

  function ProviderTypeService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    ProviderTypeModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'provider_types';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getProviderTypes: getProviderTypes,
      getProviderType: getProviderType,
      saveProviderType: saveProviderType,
      deleteProviderType: deleteProviderType,
      changeProviderTypeStatus: changeProviderTypeStatus,
      changeProviderTypeDefault: changeProviderTypeDefault,
      openProviderTypesModal: openProviderTypesModal,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getProviderTypes(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getProviderType(id, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveProviderType(item, language) {
      function success(response) {
        var msg = item.id ? 'MODIFIED_PROVIDER_TYPE' : 'NEW_ADDED_PROVIDER_TYPE';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      item.lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      return RestResource.request(method, url, item, success, failure);
    }

    function deleteProviderType(item, successCallback) {
      var params = {
        title: 'SURE_TO_DELETE_PROVIDER_TYPE',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'DELETED_PROVIDER_TYPE',
      };

      var url = apiUrl + '/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function changeProviderTypeStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function changeProviderTypeDefault(item, getItemsCallback) {
      var url = apiUrl + '/' + item.id;

      item.predefined = true;

      var params = {
        provider_type: {
          predefined: true,
        },
        set_default: true,
      };

      function success() {
        var msg = $translate('DEFAULT_PROVIDER_TYPE_CHANGED');
        utils._successMsg(msg);

        return getItemsCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function openProviderTypesModal(getItemsCallback) {
      ProviderTypeModalService.openProviderTypes(getItemsCallback);
    }
  }
})();
